import React, { forwardRef, Ref } from 'react';
import ReactDatePicker from 'react-datepicker';
import styled, { css } from 'styled-components';
import { colors } from '../../config/styles';
import { theme } from '../../styles/theme';
import { PositioningStrategy } from '@popperjs/core/lib/popper-lite';

interface IProps {
  placeholderText?: string;
  selectedValue: Date;
  dateFormat?: string;
  onChange: (date: Date | null) => void;
  autoFocus?: boolean;
  hasError?: boolean;
  positionStrategy?: PositioningStrategy;
}

const Wrapper = styled.div<{ $hasError?: boolean }>`
  .react-datepicker {
    display: flex;

    .react-datepicker__time-container {
      flex: 0 0 auto;
      width: 120px;
      height: 100%;
      border-left: 1px solid ${theme.colors.border};
    }

    .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
      border-top-right-radius: 2px;
    }

    .react-datepicker__header--time {
      padding: 6px 8px;
      border-bottom: 1px solid ${theme.colors.border};
      background-color: unset;
      text-align: left;
    }

    .react-datepicker__header--time .react-datepicker-time__header {
      font-size: 12px;
      font-weight: 600;
      line-height: 18px;
      color: ${theme.colors.secondary900};
    }
  }

  ${({ $hasError }) =>
    $hasError &&
    css`
      .react-datepicker__input-container input {
        border-color: ${colors.mainError};
      }
    `}
`;

export default forwardRef(
  (
    {
      placeholderText = 'Date',
      selectedValue,
      onChange,
      dateFormat,
      autoFocus = false,
      hasError,
      positionStrategy,
    }: IProps,
    ref: Ref<ReactDatePicker>,
  ) => {
    return (
      <Wrapper $hasError={hasError}>
        <ReactDatePicker
          ref={ref}
          placeholderText={placeholderText}
          selected={selectedValue}
          strictParsing
          dateFormat={dateFormat}
          onChange={onChange}
          disabledKeyboardNavigation
          autoFocus={autoFocus}
          showTimeSelect
          formatWeekDay={(weekdayStr) => weekdayStr.charAt(0)}
          popperPlacement={'bottom-start'}
          showPopperArrow={false}
          popperProps={{
            strategy: positionStrategy || 'fixed',
          }}
          popperModifiers={[
            {
              name: 'preventOverflow',
              enabled: false,
            },
          ]}
        />
      </Wrapper>
    );
  },
);
